import { Link, useParams } from "react-router-dom";
import FloatingButton from "../Shared/FloatingButton/FloatingButton";
import styles from "./../GameSelectPage/GameSelectPage.module.scss";
import { FcSpeaker, FcUndo, FcVoicePresentation } from "react-icons/fc";
import { FiSettings } from "react-icons/fi";
import { useEffect, useState } from "react";
import Card from "./Card/Card";
import { useSelector } from "react-redux";
import { GlobalState } from "../../redux/store";
import { strings } from "../../util/language";

const IMAGE = "/images/memory5.png";

const generateShuffledCards = (id?: string) => {
  const cards2: any = [];
  let i: number = 0;

  switch (id) {
    case "0":
      i = 0;

      while (i < 6) {
        const random1 = Math.floor(Math.random() * 11);
        const random2 = Math.floor(Math.random() * 11);
        const result = random1 + random2;

        const results = cards2.map((card: any) => card?.result);

        if (!results.includes(result)) {
          cards2.push({
            num1: random1,
            num2: random2,
            result: result,
            matched: false,
          });

          i++;
        }
      }
      break;

    case "1":
      i = 0;

      while (i < 6) {
        const random1 = Math.floor(Math.random() * 11);
        const random2 = Math.floor(Math.random() * 11);
        const result = random1 * random2;

        const results = cards2.map((card: any) => card?.result);

        if (!results.includes(result)) {
          cards2.push({
            num1: random1,
            num2: random2,
            result: result,
            matched: false,
          });

          i++;
        }
      }
      break;

    case "2":
      i = 0;

      while (i < 6) {
        const random1 = Math.floor(Math.random() * 21 + 1);
        const random2 = Math.floor(Math.random() * 11 + 1);
        const result = random1 - random2;

        const results = cards2.map((card: any) => card?.result);

        if (!results.includes(result) && result > 0) {
          cards2.push({
            num1: random1,
            num2: random2,
            result: result,
            matched: false,
          });

          i++;
        }
      }
      break;

    case "3":
      i = 0;

      while (i < 6) {
        const random1 = Math.floor(Math.random() * 101);
        const random2 = Math.floor(Math.random() * 10 + 1);
        const result = random1 / random2;

        const results = cards2.map((card: any) => card?.result);

        if (
          !results.includes(result) &&
          result > 0 &&
          result % 1 === 0 &&
          result < 11
        ) {
          cards2.push({
            num1: random1,
            num2: random2,
            result: result,
            matched: false,
          });

          i++;
        }
      }
      break;
  }

  // duplo od proslog arraya, promijeni order ako je veci od 0
  const cardsNoImage = cards2.map((card: any) => ({ ...card, image: false }));
  const cardsImage = cards2.map((card: any) => ({ ...card, image: true }));
  const shuffledCards = [...cardsNoImage, ...cardsImage]
    .sort(() => Math.random() - 0.5)
    .map((card) => ({
      ...card,
      id: Math.random(),
    }));

  return shuffledCards;
};

const GamePage = () => {
  const [cards, setCards] = useState<any>([]);
  const [turns, setTurns] = useState(0);
  const [choiceOne, setChoiceOne] = useState<any>(null);
  const [choiceTwo, setChoiceTwo] = useState<any>(null);
  const [disabled, setDisabled] = useState<boolean>(false);
  const [cardsImages, setCardsImages] = useState([{}]);
  const [loading, setLoading] = useState(false);

  const { language } = useSelector((state: GlobalState) => state.settings);

  const { id } = useParams();
  const sign = "+";

  const style = {
    backgroundImage: `url(${IMAGE})`,
    backgroundSize: "cover",
  };

  // shuffle
  const shuffle = () => {
    setChoiceOne(null);
    setChoiceTwo(null);

    setLoading(true);

    setCards(() => generateShuffledCards(id));
    setTurns(0);
    setLoading(false);
  };

  const handleChoice = (card: any) => {
    choiceOne ? setChoiceTwo(card) : setChoiceOne(card);
  };

  useEffect(() => {
    if (choiceOne && choiceTwo) {
      setDisabled(true);
      if (choiceOne.result === choiceTwo.result) {
        setCards((prevCards: any) => {
          return prevCards.map((card: any) => {
            if (card.result === choiceOne.result) {
              return { ...card, matched: true };
            } else {
              return card;
            }
          });
        });
      }

      setTimeout(() => resetTurn(), 1000);
    }
  }, [choiceOne, choiceTwo]);

  useEffect(() => {
    shuffle();
  }, []);

  const resetTurn = () => {
    setChoiceOne(null);
    setChoiceTwo(null);
    setTurns((prevTurns) => prevTurns + 1);
    setDisabled(false);
  };

  return (
    <div style={style} className={styles.memoryPage}>
      <button onClick={shuffle} className={styles.start}>
        {strings[language].homePage.start}
      </button>
      {loading ? (
        <></>
      ) : (
        <div className={styles.memoryGrid}>
          {cards.map((card: any) => (
            <Card
              card={card}
              key={card.id}
              handleChoice={handleChoice}
              flipped={card === choiceOne || card === choiceTwo || card.matched}
              disabled={disabled}
              id={id || "0"}
            />
          ))}
        </div>
      )}

      <Link to="/game">
        <FloatingButton
          icon={<FcUndo size={30} className="floating-button-icon" />}
          style={{ top: "10px", left: "10px" }}
        />
      </Link>
      <Link to="/settings">
        <FloatingButton
          icon={<FiSettings size={30} className="floating-button-icon" />}
          style={{ top: "10px", right: "10px" }}
        />
      </Link>
    </div>
  );
};

export default GamePage;
